import axios from 'axios'
const API_URL = process.env.REACT_APP_BASE_API_URL
const CREATE_BOARD_MEMBER = `${API_URL}/stakeholders/board-members`
const COMPLIANCE_MEETING = `${API_URL}/compliance/meetings`

export const createBoardMember = (payload: any, companyId: number) => {
  return axios.post(`${CREATE_BOARD_MEMBER}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getBoardMember = (
  companyId: number,
  page: number,
  pageSize: number,
  type?: string,
  sortBy?: string
) => {
  return axios.get(
    `${CREATE_BOARD_MEMBER}?page=${page}&pageSize=${pageSize}${type ? `&type=${type}` : ''}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const importBoardMembers = (data: any, companyId: number) => {
  return axios.post(
    `${CREATE_BOARD_MEMBER}/csv/import`,
    {boardMembers: data},
    {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const exportBoardMembers = (companyId: number) => {
  return axios.get(`${CREATE_BOARD_MEMBER}/csv/export`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getBoardMemberStatistics = (companyId: number) => {
  return axios.get(`${CREATE_BOARD_MEMBER}/statistics`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getboardMemberDetails = (boardMemberId: string, companyId: number) => {
  return axios.get(`${CREATE_BOARD_MEMBER}/${boardMemberId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateBoardMember = (payload: any, companyId: number, boardMemberId: string) => {
  return axios.post(`${CREATE_BOARD_MEMBER}/${boardMemberId}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const deleteBoardMember = (memberId: string, companyId: number) => {
  return axios.delete(`${CREATE_BOARD_MEMBER}/${memberId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getBoardMemberDetails = (memberId: string, companyId: number) => {
  return axios.get(`${CREATE_BOARD_MEMBER}/${memberId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getMeetingLists = (
  meetingType: string,
  page?: number,
  pageSize?: number,
  email?: string,
  attendanceType?: string,
  meetingDate?: string
) => {
  console.log(email,'email');
  
  return axios.get(
    `${COMPLIANCE_MEETING}/all?meetingCategory=${meetingType}${page ? `&page=${page}` : ''}${
      pageSize ? `&pageSize=${pageSize}` : ''
    }${email ? `&email=${email}` : ''}${attendanceType ? `&attendance=${attendanceType}` : ''}${meetingDate ? `&date=${meetingDate}` : ''}`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}
